export default __webpack_public_path__ + "static/media/404.ef898c4f.svg";